import React from 'react';

import { NoteType } from '../recruitments/Recruitments.types';

import { EntryContainer } from './EntryContainer';

type NoteEntryProps = {
  note: NoteType;
};

export const NoteEntry: React.FC<NoteEntryProps> = ({ note }) => {
  return (
    <EntryContainer date={note.createdDate} user={note.createdBy} header={<div>Note created by: {note.createdBy}</div>}>
      <div>{note.content}</div>
    </EntryContainer>
  );
};
